import React, {useEffect} from 'react';
import {MainList} from './components';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';


import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExistToAppIcon from '@material-ui/icons/ExitToApp';

import {Copyright} from '../../components'
import { withRouter } from "react-router";
import { logoutUser } from '../../services/auth.service';
import { useAuth } from "../../context/auth";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import Avatar from "@material-ui/core/Avatar";
import {AccountCircle} from "@material-ui/icons";
import PoweredbyDQ from "../../assets/images/PoweredByDQ_Default.png";
const drawerWidth = 275;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#F4EEEE',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: '#F4EEEE',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    content: {
        backgroundColor: "#F4F4F4",
        flexGrow: 1,
        paddingTop: 0,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 64,
        },
    },
    menuButton: {
        marginRight: 36,
        color: theme.palette.primary.main,
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    drawerPaper: {
        height: '96vh',
        position: 'fixed',
        top: '15px',
        left: '9px',
        borderRadius: '20px',
        paddingTop: '10px',
        whiteSpace: 'nowrap',
        width: '265px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        background: "linear-gradient(to bottom, #FFAC46 0%, #FF5979 50%, #E7466E 100%)",
        color: "white",
        [theme.breakpoints.down('lg')]: {
            // width: '14%',
            overflowX: 'hidden',
        },
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('lg')]: {
            width: theme.spacing(9),
        },
    },
    container: {
        backgroundColor: "#F4F4F4",
        paddingBottom: '15px !important',
        padding: '0px !important',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position:'relative',
        paddingTop:'40px !important',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: props => (props.isDrawerOpen ? '255px' : '114px'),
        width: props => `calc(95vw - ${props.isDrawerOpen ? '210px' : '50px'})`,

        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
            marginLeft: '0 !important',
        },
        [theme.breakpoints.down('md')]: {
            paddingTop:'47px !important',
            marginLeft: '0 !important',
            width: props => `calc(109vw - ${props.isDrawerOpen ? '210px' : '100px'})`,
        },
    },
    logoContainer: {
        marginBottom:'40px',
        [theme.breakpoints.down('md')]: {
            display:'none',
        },
    },
    logoContainerMbl: {
        marginBottom:'20px',
    },
    menuToggle:{
        [theme.breakpoints.down('md')]: {
            display:'none'
        },
    },
    logo: {
        position:'absolute',
        right: 0,
        height: 80,
        zIndex:'3',
        cursor: 'pointer',
        [theme.breakpoints.down('lg')]: {
            height: '60px',
            top:'7px',
        },
    },
    drawerClose: {
        width: theme.spacing(9),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        [theme.breakpoints.up('lg')]: {
            width: theme.spacing(9),
        },
    },
}));


// - List
// - Accounts
// - Config
// - Subscriptions
// - Module UI Conf
// - Badge UI Conf
// - All Modules (Areas)
// - All Badges

const pathToLabelHeadMap = {
    // 'home': 'Overview',
    // 'password__change': 'Change Password',
    // 'ui_config': 'UI Configs',
    //
    // 'overview': 'Applications Overview',
    //
    // 'company__view': 'Organization Information',
    // 'company__update': 'Update Organization Information',
    //
    // 'application__list': 'Submitted Applications',
    // 'application__create': 'Create Application',

    'dq_pro__home': 'Home',
    'dq_pro__products': 'Your Products',
    'dq_pro__sales__resources': 'Sales Resources',
    'dq_pro__client__list': 'Client List',
    'dq_pro__assessment__list': 'Assessment List',
};


const Main = props => {
    const { children, history, location } = props;
    const [isDrawerOpen, setDrawerOpen] =  React.useState(
        JSON.parse(localStorage.getItem('isDrawerOpen')) || true
    );
    const classes = useStyles({ isDrawerOpen });
    const [labelHeading, setLabelHeading] = React.useState('');
    const { setAuthToken, setAuthUser, authUser } = useAuth();

    const [pathKey, setPathKey] = React.useState('dq_pro__home');

    const anchorRefUserMenu = React.useRef(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(true);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1200);

    // Handle sidebar toggle and persist state
    const handleDrawerToggle = () => {
        setDrawerOpen((prev) => {
            const newState = !prev;
            localStorage.setItem('isDrawerOpen', JSON.stringify(newState));
            return newState;
        });
    };
    // Ensure `isDrawerOpen` is set correctly on refresh
    React.useEffect(() => {
        const storedState = localStorage.getItem('isDrawerOpen');
        if (storedState !== null) {
            setDrawerOpen(JSON.parse(storedState));
        }
    }, []);

    // User Menu Handlers
    const handleUserMenuToggle = () => {
        setOpenUserMenu((prevOpen) => !prevOpen);
    };

    const handleUserMenuClose = (event) => {
        if (anchorRefUserMenu.current && anchorRefUserMenu.current.contains(event.target)) {
            return;
        }

        setOpenUserMenu(false);
    };

    const updateScreenSize = () => {
        setIsMobile(window.innerWidth <= 600);
    };

    const handleChangePassword = (event) => {
        handleUserMenuClose(event);
        history.push('/password/change');
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenUserMenu(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevUserMenuOpen = React.useRef(openUserMenu);
    React.useEffect(() => {
        if (prevUserMenuOpen.current === true && openUserMenu === false) {
            anchorRefUserMenu.current.focus();
        }

        prevUserMenuOpen.current = openUserMenu;
    }, [openUserMenu]);

    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_user);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.refresh_token);
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    useEffect( ()=>{

        const path_parts = location.pathname.split('/');
        console.log('path_parts --> ', path_parts)
        if (path_parts.length > 1) {
            if (path_parts.length < 3) {
                const path_key = path_parts[1];
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            } else {
                const path_key = `${path_parts[1]}__${path_parts[2]}`;
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            }
        }

    },[location]);

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <div className={classes.logoContainer}>
                <img
                    src={PoweredbyDQ}
                    alt="Logo"
                    className={classes.logo}
                />
            </div>
            {/* AppBar for Mobile */}
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        aria-label="menu"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon/>
                    </IconButton>
                    {/*<Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>*/}
                    {/*    {labelHeading}*/}
                    {/*</Typography>*/}

                    <div>
                        {/*<IconButton*/}
                        {/*    style={{marginRight:'30px'}}*/}
                        {/*    ref={anchorRefUserMenu}*/}
                        {/*    aria-controls={openUserMenu ? 'menu-list-grow' : undefined}*/}
                        {/*    aria-haspopup="true"*/}
                        {/*    onClick={handleUserMenuToggle}>*/}
                        {/*    <Avatar style={{color:'white', backgroundColor:'#052F44', height:'55px', width: '55px', }}>*/}
                        {/*        <AccountCircle style={{ height:'35px', width:'35px', }}/>*/}
                        {/*    </Avatar>*/}
                        {/*</IconButton>*/}
                        <Popper isDrawerOpen={openUserMenu} anchorEl={anchorRefUserMenu.current} role={undefined} transition disablePortal>
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                >
                                    {/*<Typography*/}
                                    {/*    color="inherit" noWrap className={classes.user_email}>{authUser.email}*/}
                                    {/*</Typography>*/}
                                    <Paper style={{border:'1px solid #052F44'}}>
                                        <ClickAwayListener onClickAway={handleUserMenuClose}>
                                            <MenuList autoFocusItem={openUserMenu} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                <MenuItem onClick={handleChangePassword}>Change Password</MenuItem>
                                                <br/>
                                                <Divider style={{ backgroundColor: '#052F44' }}/>
                                                <MenuItem style={{position:'bottom', right:'0'}} onClick={handleLogout}>Logout</MenuItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </div>

                    {/*<IconButton color="inherit" onClick={handleLogout}>*/}
                    {/*    <ExistToAppIcon/>*/}
                    {/*</IconButton>*/}
                </Toolbar>
                <div className={classes.logoContainerMbl}>
                    <img
                        src={PoweredbyDQ}
                        alt="Logo"
                        className={classes.logo}
                    />
                </div>
            </AppBar>

            {/* Drawer */}
            <Drawer
                style={{ marginRight:isDrawerOpen ? '25px' : '0px',}}
                variant={isMobile ? "temporary" : "permanent"}
                classes={{
                    paper: clsx(classes.drawerPaper, {
                        [classes.drawerClose]: !isDrawerOpen,
                    }),
                }}
                open={isDrawerOpen}
                onClose={handleDrawerToggle} // Only for mobile
                ModalProps={{
                    keepMounted: true, // Improve performance on mobile
                }}
            >
                <div className={classes.menuToggle}>
                    <IconButton style={{color:'#fff',marginLeft:'13px'}} onClick={handleDrawerToggle}>
                        {isDrawerOpen ? <ChevronLeftIcon /> : <MenuIcon />}
                    </IconButton>
                </div>
                <MainList path={pathKey} isDrawerOpen={isDrawerOpen} logoutAction={handleLogout}/>
            </Drawer>
            <main className={classes.content}>
                <Container maxWidth={false} className={classes.container}>
                    {children}
                    <footer className={classes.footer} style={{marginTop: 'auto', paddingTop: '30px'}}>
                        <Box sx={{pt: {xs: '3', sm: '4'}}}>
                            <Copyright/>
                        </Box>
                    </footer>
                </Container>
            </main>
        </div>
    );
}

export default withRouter(Main);